import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faUpload, faFileImage } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from 'react-bootstrap';
import { TextField } from "../common/FormComponents";
import {toArray} from "../common/util";
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import { MenuItem } from '@material-ui/core';
import { chapterSelector } from '../redux/selectors';

const validate = values => {
    const errors = {};

    if (!values.title) {
        errors.title = '* Required'
    }
    if (!values.chapter) {
        errors.chapter = '* Required';
    }

    return errors;
};

class ScreenshotsForm extends Component {
    render () {
        const { handleSubmit } = this.props;
        const onKeyPress = (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
            }
        };
        let dropzoneRef;
        return (
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col md={6}>
                        <Field component={TextField}
                            name="title"
                            type="text"
                            label="Title"
                            fullWidth
                            onChange={this.handleChange}
                            onKeyPress={onKeyPress}
                        />
                        </Col>
                    <Col md={6}>
                        <Field component={TextField}
                            name="chapter"
                            select
                            label="Chapter"
                            fullWidth
                            helperText={<span></span>}
                        >
                            {toArray(this.props.chapters)
                                .sort((a, b) => (b.id - a.id))
                                .map((chapter) => (
                                <MenuItem key={chapter.id} value={chapter.id}>{chapter.game.title}</MenuItem>
                            ))}
                        </Field>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Dropzone
                            accept="image/jpeg, image/png, image/gif"
                            ref={(node) => { dropzoneRef = node; }}
                            onDrop={this.props.handleDrop}
                            disableClick
                            multiple={false}
                            maxSize={5242880}
                            style={{ 
                                width: "auto",
                                display: "flex",
                                minHeight: '200px',
                                marginBottom: '10px',
                                borderWidth: '2px',
                                borderColor: '#555',
                                borderStyle: 'dashed',
                            }}
                        >
                            { this.props.image ? (
                                <img style={{maxWidth:"100%"}} src={this.props.image.preview} alt="" />
                            ) : null}
                        </Dropzone>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Button type="button" onClick={() => { dropzoneRef.open() }}>
                            <FontAwesomeIcon className="text-primary" icon={faFileImage} fixedWidth /> Browse
                        </Button>
                        <span> </span>
                        <Button type="submit" disabled={this.props.pristine || this.props.pending}>
                            {(this.props.pending) ? (
                            <FontAwesomeIcon className="text-primary" icon={faSpinner} spin fixedWidth />
                            ) : (<FontAwesomeIcon className="text-primary" icon={faUpload} fixedWidth />)}
                            Upload
                        </Button>
                    </Col>
                </Row>
            </Form>
        )
    }
};

const mapStateToProps = (state) => ({
    chapters: chapterSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({ form: 'screenshotsForm', validate, })(ScreenshotsForm))


// WEBPACK FOOTER //
// ./src/Media/ScreenshotsForm.js